<template>
  <v-container grid-list-md>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        Panel principal
      </v-toolbar-title>
    </v-toolbar>
    <v-layout wrap>
      <div class="flex xs12 md4">
        <v-card>
          <v-layout align-center justify-center v-if="loadingActivations">
            <v-progress-circular
              indeterminate
              color="blue"
              size="250"
              class="mb-0"
            ></v-progress-circular>
          </v-layout>
          <canvas
            v-show="!loadingActivations && activaciones.length !== 0"
            id="chartWeek"
            width="400"
            height="300"
          ></canvas>
          <div style="margin: 0 10px;">
            <v-btn
              v-if="!loadingActivations && activaciones.length !== 0"
              block
              color="primary"
              dark
              @click.stop="myChartWeek.resetZoom"
            >
              Reiniciar zoom
            </v-btn>
          </div>

          <v-card-title primary-title>
            <div>
              <div class="headline">Actividad diaria</div>
              <span class="grey--text">Estadísticas de cada día de esta semana</span>
            </div>
          </v-card-title>
          <v-divider />
          <v-card-text
            class="v-icon"
            style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon>date_range</v-icon>
            &nbsp; Semana {{ week }} de {{ year }}
          </v-card-text>
        </v-card>
      </div>

      <div class="flex xs12 md4">
        <v-card>
          <v-layout align-center justify-center v-if="loadingActivations">
            <v-progress-circular
              indeterminate
              color="blue"
              size="250"
              class="mb-0"
            ></v-progress-circular>
          </v-layout>
          <canvas
            v-show="!loadingActivations && activaciones.length !== 0"
            id="chartYear"
            width="400"
            height="300"
          ></canvas>
          <div style="margin: 0 10px;">
            <v-btn
              v-if="!loadingActivations && activaciones.length !== 0"
              block
              color="primary"
              dark
              @click.stop="myChartYear.resetZoom()"
            >
              Reiniciar zoom
            </v-btn>
          </div>

          <v-card-title primary-title>
            <div>
              <div class="headline">Evolución mensual</div>
              <span class="grey--text">Agrupación por meses de este año</span>
            </div>
          </v-card-title>
          <v-divider />
          <v-card-text
            class="v-icon"
            style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon>date_range</v-icon>
            &nbsp; Intervalo anual de {{ year }}
          </v-card-text>
        </v-card>
      </div>

      <div class="flex xs12 md4">
        <v-card>
          <v-layout align-center justify-center v-if="loadingActivations">
            <v-progress-circular
              indeterminate
              color="blue"
              size="250"
              class="mb-0"
            ></v-progress-circular>
          </v-layout>
          <canvas
            v-show="!loadingActivations && activaciones.length !== 0"
            id="chartDay"
            width="400"
            height="300"
          ></canvas>
          <div style="margin: 0 10px;">
            <v-btn
              v-if="!loadingActivations && activaciones.length !== 0"
              block
              color="primary"
              dark
              @click.stop="myChartDay.resetZoom()"
            >
              Reiniciar zoom
            </v-btn>
          </div>

          <v-card-title primary-title>
            <div>
              <div class="headline">Horas más activas</div>
              <span class="grey--text">Registro de hoy</span>
            </div>
          </v-card-title>
          <v-divider />
          <v-card-text
            class="v-icon"
            style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon>date_range</v-icon>
            &nbsp; {{ day }}
          </v-card-text>
        </v-card>
      </div>
    </v-layout>
    <!--Primera fila-->

    <v-layout wrap>
      <div class="flex xs12 md4">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">Grupo más activo</div>
              <v-progress-linear
                indeterminate
                color="blue"
                class="mb-0"
                v-if="loadingGroups"
              ></v-progress-linear>
              <span
                v-if="!loadingGroups"
                v-for="item in rankingGrupos.slice(0, 5)"
                class="grey--text"
              >
                <ProfileLink
                  :key="item.key"
                  v-bind:idKey="item.key"
                  type="group"
                />
                <br />
              </span>
            </div>
          </v-card-title>
          <v-card-text
            v-if="!loadingGroups && grupos.length === 0"
            class="v-icon blue--text text--darken-3"
            style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon color="blue darken-3">info</v-icon>
            &nbsp; No tienes grupos registrados.
          </v-card-text>
          <v-card-text
              v-if="!loadingGroups && rankingGrupos.length === 0 && grupos.length !== 0"
              class="v-icon blue--text text--darken-3"
              style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon color="blue darken-3">info</v-icon>
            &nbsp; No tienes grupos con activaciones.
          </v-card-text>
          <v-divider />
          <v-btn flat to="/dashboard/groups">Ver todos</v-btn>
          <v-divider />
          <canvas
              v-show="!loadingGroups && rankingGrupos.length !== 0"
              id="chartGroups"
              width="400"
              height="300"
              style="padding-bottom: 10px"
          ></canvas>
        </v-card>
      </div>

      <div class="flex xs12 md4">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">Edificios más activos</div>
              <v-progress-linear
                indeterminate
                color="blue"
                class="mb-0"
                v-if="loadingBuildings"
              ></v-progress-linear>
              <span
                v-if="!loadingBuildings"
                v-for="item in edificiosMasActivos.slice(0, 5)"
                class="grey--text"
              >
                <ProfileLink
                  :key="item.key"
                  v-bind:idKey="item.key"
                  type="building"
                />
                <br />
              </span>
            </div>
          </v-card-title>
          <v-card-text
            v-if="!loadingBuildings && edificios.length === 0"
            class="v-icon blue--text text--darken-3"
            style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon color="blue darken-3">info</v-icon>
            &nbsp; No tienes edificios registrados.
          </v-card-text>
          <v-card-text
              v-if="!loadingBuildings && edificiosMasActivos.length === 0 && edificios.length !== 0"
              class="v-icon blue--text text--darken-3"
              style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon color="blue darken-3">info</v-icon>
            &nbsp; No tienes edificios con activaciones.
          </v-card-text>
          <v-divider />
          <v-btn flat to="/dashboard/buildings">Ver todos</v-btn>
          <v-divider />
          <canvas
              v-show="!loadingBuildings && edificiosMasActivos.length !== 0"
              id="chartBuildings"
              width="400"
              height="300"
              style="padding-bottom: 10px"
          ></canvas>
        </v-card>
      </div>

      <div class="flex xs12 md4">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">Total de registros</div>
              <v-progress-linear
                indeterminate
                color="blue"
                class="mb-0"
                v-if="algoCargando"
              ></v-progress-linear>
              <span
                class="grey--text"
                v-if="!loadingSensors && sensores.length !== 1"
              >
                {{ sensores.length }} sensores
              </span>
              <span
                class="grey--text"
                v-if="!loadingSensors && sensores.length === 1"
              >
                {{ sensores.length }} sensor
              </span>
              <br />
              <span
                class="grey--text"
                v-if="!loadingGroups && grupos.length !== 1"
              >
                {{ grupos.length }} grupos
              </span>
              <span
                class="grey--text"
                v-if="!loadingGroups && grupos.length === 1"
              >
                {{ grupos.length }} grupo
              </span>
              <br />
              <span
                class="grey--text"
                v-if="!loadingBuildings && edificios.length !== 1"
              >
                {{ edificios.length }} edificios
              </span>
              <span
                class="grey--text"
                v-if="!loadingBuildings && edificios.length === 1"
              >
                {{ edificios.length }} edificio
              </span>
              <br />
              <span
                class="grey--text"
                v-if="!loadingNotifications && notificaciones.length !== 1"
              >
                {{ notificaciones.length }} notificaciones
              </span>
              <span
                class="grey--text"
                v-if="!loadingNotifications && notificaciones.length === 1"
              >
                {{ notificaciones.length }} notificación
              </span>
              <br />
              <span
                  class="grey--text"
                  v-if="!loadingActivations && numAlertas !== 1"
              >
                {{ numAlertas }} alertas
              </span>
              <span
                  class="grey--text"
                  v-if="!loadingActivations && numAlertas === 1"
              >
                {{ numAlertas }} alerta
              </span>
            </div>
          </v-card-title>
          <v-divider />
          <v-card-text v-if="!loadingActivations">
            {{ activaciones.length }} activaciones en total
          </v-card-text>
          <v-divider />
          <canvas
              v-show="!loadingActivations && activaciones.length !==0 && notificaciones.length !==0 && edificios.length !==0 && sensores.length !==0 && grupos.length !==0 "
              id="chartGeneral"
              width="400"
              height="300"
              style="padding-bottom: 10px"
          ></canvas>
        </v-card>
      </div>
    </v-layout>
    <!--Segunda fila-->

    <v-layout wrap>
      <div class="flex xs12 md6">
        <v-card>
          <v-card-title primary-title>
            <div style="width: -webkit-fill-available">
              <div class="headline">Últimos sensores activos</div>
              <v-progress-linear
                indeterminate
                color="blue"
                class="mb-0"
                v-if="loadingSensors"
              ></v-progress-linear>
              <div>
                <span
                  v-if="!loadingSensors"
                  v-for="item in sensoresUltimosActivos.slice(0, 5)"
                  class="grey--text"
                >
                  <v-layout mb-1 style="padding-left: 5px">
                    <ProfileLink
                      :key="item.key"
                      v-bind:idKey="item.key"
                      type="sensor"
                    />
                    <v-spacer />
                    {{ mostrarFecha(item.dateLastActivation) }}
                  </v-layout>
                </span>
              </div>
            </div>
          </v-card-title>
          <v-card-text
            v-if="!loadingSensors && sensores.length === 0"
            class="v-icon blue--text text--darken-3"
            style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon color="blue darken-3">info</v-icon>
            &nbsp; No tienes sensores registrados.
          </v-card-text>
          <v-card-text
              v-if="!loadingSensors && sensoresUltimosActivos.length === 0 && sensores.length !== 0"
              class="v-icon blue--text text--darken-3"
              style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon color="blue darken-3">info</v-icon>
            &nbsp; No tienes sensores con activaciones.
          </v-card-text>
          <v-divider />
          <v-btn flat to="/dashboard/sensors">Ver todos</v-btn>
          <v-divider />
          <canvas
              v-show="!loadingSensors && sensoresUltimosActivos.length !== 0"
              id="chartSensors"
              width="400"
              height="300"
              style="padding: 0 10px"
          ></canvas>
        </v-card>
      </div>

      <div class="flex xs12 md6">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">Últimas notificaciones</div>
              <v-progress-linear
                indeterminate
                color="blue"
                class="mb-0"
                v-if="loadingNotifications"
              ></v-progress-linear>
              <span
                v-if="!loadingNotifications"
                v-for="item in notificaciones.slice().reverse().slice(0, 5)"
                class="grey--text"
              >
                {{ item.name }}<br />
              </span>
            </div>
          </v-card-title>
          <v-card-text
            v-if="!loadingNotifications && notificaciones.length === 0"
            class="v-icon blue--text text--darken-3"
            style="font-size:inherit; justify-content: inherit;"
          >
            <v-icon color="blue darken-3">info</v-icon>
            &nbsp; No tienes notificaciones.
          </v-card-text>
          <v-divider />
          <v-btn flat to="/notifications">Ver todas</v-btn>
          <v-divider />
          <canvas
              v-show="!loadingNotifications && notificaciones.length !== 0"
              id="chartNotis"
              width="400"
              height="300"
              style="padding: 10px"
          ></canvas>
        </v-card>
      </div>
    </v-layout>
    <!--Tercera fila-->
  </v-container>
</template>

<script>
import ProfileLink from "@/components/links/ProfileLink.vue";
import firebase from "firebase";
import Chart from "chart.js";
import "chartjs-plugin-zoom";

let firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
    authDomain: "tfgr-9ed26.firebaseapp.com",
    databaseURL: "https://tfgr-9ed26.firebaseio.com",
    projectId: "tfgr-9ed26",
    storageBucket: "tfgr-9ed26.appspot.com",
    messagingSenderId: "47742064305"
  });
} else {
  firebaseApp = firebase.app();
}
export const db = firebaseApp.database();

//Panel principal donde se muestran las estadísticas de la web
export default {
  name: "Main",
  components: {
    ProfileLink
  },
  data() {
    return {
      activaciones: [],
      grupos: [],
      edificios: [],
      sensores: [],
      sensoresMasActivos: [],
      sensoresUltimosActivos: [],
      notificaciones: [],
      rankingEdificios: {},
      edificiosMasActivos: [],
      rankingGrupos: [],
      gruposMasActivos: [],
      rendered: false,
      numAlertas: 0,
      loadingNotifications: true,
      loadingSensors: true,
      loadingGroups: true,
      loadingBuildings: true,
      loadingActivations: true,
      myChartGeneral: null,
      myChartWeek: null,
      myChartYear: null,
      myChartDay: null
    };
  },
  created() {
    this.$bindAsArray(
      "notificaciones",
      db
        .ref("notifications")
        .orderByChild("dest")
        .equalTo(this.getUID),
      snap => {
        this.loadingNotifications = false;
      },
      error => {
        this.loadingNotifications = false;
      }
    );
    this.$bindAsArray(
      "sensores",
      db
        .ref("sensors")
        .orderByChild("owner")
        .equalTo(this.getUID),
      snap => {
        this.loadingSensors = false;
      },
      error => {
        this.loadingSensors = false;
      }
    );
    this.$bindAsArray(
      "grupos",
      db
        .ref("groups")
        .orderByChild("owner")
        .equalTo(this.getUID),
      snap => {
        this.loadingGroups = false;
      },
      error => {
        this.loadingGroups = false;
      }
    );
    this.$bindAsArray(
      "edificios",
      db
        .ref("buildings")
        .orderByChild("owner")
        .equalTo(this.getUID),
      snap => {
        this.loadingBuildings = false;
      },
      error => {
        this.loadingBuildings = false;
      }
    );
    this.$bindAsArray(
      "activaciones",
      db
        .ref("activations")
        .orderByChild("owner")
        .equalTo(this.getUID),
      snap => {
        this.loadingActivations = false;
      },
      error => {
        this.loadingActivations = false;
      }
    );
  },
  mounted: function() {
    this.$nextTick(function() {
      this.rendered = true;
    });
    this.generarGrafica();
  },
  watch: {
    grupos: async function () {
      if (!this.loadingGroups) {
        this.loadingGroups = true;
        this.rankingGrupos = [];
        for (let i = 0; i < this.grupos.length; i++) {
          await firebase
            .database()
            .ref("groupsSensors")
            .orderByChild("key")
            .equalTo(this.grupos[i].key)
            .once("value")
            .then(
              async function (snapshot) {
                if (snapshot.val() !== null) {
                  let migrupo = snapshot.val()[this.grupos[i].key];
                  if (
                    migrupo.sensors !== null &&
                    migrupo.sensors !== undefined
                  ) {
                    let activaciones = 0;
                    for (let j = 0; j < migrupo.sensors.length; j++) {
                      await firebase
                        .database()
                        .ref("activations")
                        .orderByChild("sensor_id")
                        .equalTo(migrupo.sensors[j])
                        .once("value")
                        .then(function(snapshot) {
                          if (snapshot.val() !== null) {
                            activaciones += Object.keys(snapshot.val()).length;
                          }
                        });
                    }
                    if (activaciones !== 0) {
                      this.rankingGrupos.push({
                        key: this.grupos[i].key,
                        name: this.grupos[i].name,
                        number: activaciones
                      });
                    }
                  }
                }
              }.bind(this)
            );
        }
        this.rankingGrupos.sort(function (a, b) {
          if (a.number > b.number) {
            return -1;
          }
          if (a.number < b.number) {
            return 1;
          }
          // a debe ser igual b
          return 0;
        });
        let nombres = [];
        let valores = [];
        for (let i = 0; i < this.rankingGrupos.length; i++) {
          nombres.push(this.rankingGrupos[i].name);
          valores.push(this.rankingGrupos[i].number);
        }
        let ctxGroups = document.getElementById("chartGroups").getContext("2d");
        this.myChartGeneral = new Chart(ctxGroups, {
          type: "horizontalBar",
          data: {
            labels: nombres.slice(0, 5),
            datasets: [
              {
                label: "nº de activaciones",
                lineTension: 0.2,
                borderWidth: 1.5,
                showLine: true,
                data: valores.slice(0, 5),
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)'
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)'
                ],
              }
            ]
          },
          options: {
            tooltips: {
              mode: "index",
              intersect: true
            },
            responsive: true,
            legend: {
              display: false,
              position: "top"
            },
            title: {
              display: true,
              text: "Activaciones por grupo"
            },
            animation: {
              animateScale: true,
              animateRotate: true
            },
            circumference: Math.PI,
            rotation: -Math.PI,
            scales: {
              xAxes: [
                {
                  display: true,
                  stacked: false,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ],
              yAxes: [
                {
                  display: true,
                  stacked: false,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            },
            plugins: {
              zoom: {
                pan: {
                  enabled: true,
                  mode: "y",
                  speed: 0.5
                },
                zoom: {
                  enabled: true,
                  mode: "y"
                }
              }
            }
          }
        });
        this.loadingGroups = false;
      }
    },
    sensoresMasActivos: function() {
      this.generarGraficaSensors();
    },
    notificaciones: function() {
      if (!this.loadingNotifications) {
        let nombres = ["Sensor creado", "Alertas"];
        let valores = [0, 0];
        for (let i = 0; i < this.notificaciones.length; i++) {
          if (this.notificaciones[i].type === "sensor_created") {
            valores[0]++;
          }
          if (this.notificaciones[i].type === "alert") {
            valores[1]++;
          }
        }
        let ctxGeneral = document.getElementById("chartNotis").getContext("2d");
        this.myChartGeneral = new Chart(ctxGeneral, {
          type: "polarArea",
          data: {
            labels: nombres,
            datasets: [
              {
                label: "nº de alertas",
                lineTension: 0.2,
                borderWidth: 1.5,
                showLine: true,
                data: valores,
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)'
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)'
                ],
              }
            ]
          },
          options: {
            tooltips: {
              mode: "index",
              intersect: true
            },
            responsive: true,
            legend: {
              display: true,
              position: "top"
            },
            title: {
              display: true,
              text: "Tipos de notificaciones"
            },
            animation: {
              animateScale: true,
              animateRotate: true
            },
            circumference: Math.PI,
            rotation: -Math.PI,
            scales: {
              xAxes: [
                {
                  display: false,
                  stacked: false,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ],
              yAxes: [
                {
                  display: false,
                  stacked: false,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            },
            plugins: {
              zoom: {
                pan: {
                  enabled: true,
                  mode: "y",
                  speed: 0.5
                },
                zoom: {
                  enabled: true,
                  mode: "y"
                }
              }
            }
          }
        });
      }
    },
    sensores: async function() {
      if (!this.loadingSensors) {
        let masactivos = [];
        this.rankingEdificios = {};
        this.loadingBuildings = true;
        this.loadingSensors = true;

        for (let i = 0; i < this.sensores.length; i++) {
          await firebase
            .database()
            .ref("activations")
            .orderByChild("sensor_id")
            .equalTo(this.sensores[i].key)
            .once("value")
            .then(function (snapshot) {
              if (snapshot.val() !== null) {
                if (
                  this.sensores[i].building !== null &&
                  this.sensores[i].building !== undefined
                ) {
                  this.rankingEdificios[this.sensores[i].building] ? this.rankingEdificios[this.sensores[i].building] += Object.keys(snapshot.val()).length : this.rankingEdificios[this.sensores[i].building] = Object.keys(snapshot.val()).length;
                }
                masactivos.push({
                  key: this.sensores[i].key,
                  name: this.sensores[i].name,
                  number: Object.keys(snapshot.val()).length
                });
                masactivos.sort(function (a, b) {
                  if (a.number > b.number) {
                    return -1;
                  }
                  if (a.number < b.number) {
                    return 1;
                  }
                  // a debe ser igual b
                  return 0;
                });
              }
            }.bind(this));
        }
        let claves = Object.keys(this.rankingEdificios);
        let valores = Object.values(this.rankingEdificios);
        let nombres = [];
        this.edificiosMasActivos = [];
        for (let i = 0; i < claves.length; i++) {
          this.edificiosMasActivos.push({ key: claves[i], number: valores[i] });
          await firebase
            .database()
            .ref("buildings")
            .orderByChild("key")
            .equalTo(claves[i])
            .once("value")
            .then(function (snapshot) {
              if (snapshot.val() !== null) {
                nombres.push(snapshot.val()[claves[i]].name);
              }
            });
        }
        this.edificiosMasActivos.sort(function (a, b) {
          if (a.number > b.number) {
            return -1;
          }
          if (a.number < b.number) {
            return 1;
          }
          // a debe ser igual b
          return 0;
        });
        let ctxBuildings = document.getElementById("chartBuildings").getContext("2d");
        this.myChartGeneral = new Chart(ctxBuildings, {
          type: "bar",
          data: {
            labels: nombres.slice(0, 5),
            datasets: [
              {
                label: "nº de activaciones",
                lineTension: 0.2,
                borderWidth: 1.5,
                showLine: true,
                data: valores.slice(0, 5),
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)'
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)'
                ],
              }
            ]
          },
          options: {
            tooltips: {
              mode: "index",
              intersect: true
            },
            responsive: true,
            legend: {
              display: false,
              position: "top"
            },
            title: {
              display: true,
              text: "Activaciones por edificio"
            },
            animation: {
              animateScale: true,
              animateRotate: true
            },
            circumference: Math.PI,
            rotation: -Math.PI,
            scales: {
              xAxes: [
                {
                  display: true,
                  stacked: false,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ],
              yAxes: [
                {
                  display: true,
                  stacked: false,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            },
            plugins: {
              zoom: {
                pan: {
                  enabled: true,
                  mode: "x",
                  speed: 0.5
                },
                zoom: {
                  enabled: true,
                  mode: "x"
                }
              }
            }
          }
        });
        this.loadingBuildings = false;

        masactivos.sort(function (a, b) {
          if (a.number > b.number) {
            return -1;
          }
          if (a.number < b.number) {
            return 1;
          }
          // a debe ser igual b
          return 0;
        });
        this.sensoresMasActivos = masactivos;

        let ultimosactivos = [];
        for (let i = 0; i < this.sensores.length; i++) {
          if (this.sensores[i].dateLastActivation !== null && this.sensores[i].dateLastActivation !== undefined) {
            ultimosactivos.push({
              key: this.sensores[i].key,
              dateLastActivation: this.sensores[i].dateLastActivation
            });
          }
        }
        ultimosactivos.sort(function (a, b) {
          if (a.dateLastActivation > b.dateLastActivation) {
            return -1;
          }
          if (a.dateLastActivation < b.dateLastActivation) {
            return 1;
          }
          // a debe ser igual b
          return 0;
        });
        this.sensoresUltimosActivos = ultimosactivos;
        this.loadingSensors = false;
      }
    },
    // whenever activaciones changes, this function will run
    activaciones: function() {
      if (!this.loadingActivations) {
        this.generarGrafica();
        this.numAlertas = 0;
        let numActivacionesWeek = new Array(7).fill(0);
        let numAlertasWeek = new Array(7).fill(0);
        let numActivacionesYear = new Array(12).fill(0);
        let numAlertasYear = new Array(12).fill(0);
        let numActivacionesDay = new Array(24).fill(0);
        let numAlertasDay = new Array(24).fill(0);

        for (let i = 0; i < this.activaciones.length; i++) {
          let dateStr = JSON.parse('"' + this.activaciones[i].date + '"');
          let date = new Date(dateStr);
          let actualDate = new Date();
          let diaSemana = date.getDay() - 1;
          if (diaSemana < 0) {
            diaSemana = 5;
          }
          if (this.activaciones[i].notified === true) {
            this.numAlertas++;
            if (this.getWeekNumber(date) === this.getWeekNumber(actualDate)) {
              numAlertasWeek[diaSemana] += 1;
            }
            if (date.getFullYear() === actualDate.getFullYear()) {
              numAlertasYear[date.getMonth()] += 1;
            }
            if (date.getDate() === actualDate.getDate()) {
              numAlertasDay[date.getHours()] += 1;
            }
          }
          if (this.getWeekNumber(date) === this.getWeekNumber(actualDate)) {
            numActivacionesWeek[diaSemana] += 1;
          }
          if (date.getFullYear() === actualDate.getFullYear()) {
            numActivacionesYear[date.getMonth()] += 1;
          }
          if (date.getDate() === actualDate.getDate()) {
            numActivacionesDay[date.getHours()] += 1;
          }
        }
        // Code that will run only after the
        // entire view has been rendered
        let ctxWeek = document.getElementById("chartWeek").getContext("2d");
        this.myChartWeek = new Chart(ctxWeek, {
          type: "horizontalBar",
          data: {
            labels: [
              "Lunes",
              "Martes",
              "Miércoles",
              "Jueves",
              "Viernes",
              "Sábado",
              "Domingo"
            ],
            datasets: [
              {
                label: "nº de alertas",
                lineTension: 0.2,
                borderWidth: 1,
                showLine: true,
                data: numAlertasWeek,
                backgroundColor: "rgba(25,118,210,0.5)",
                borderColor: "rgba(25,118,210, 1)"
              },
              {
                label: "nº de activaciones",
                lineTension: 0.2,
                showLine: true,
                data: numActivacionesWeek,
                backgroundColor: "rgba(255, 99, 132, 0.3)",
                borderColor: "rgba(255, 99, 132, 1)",
                borderWidth: 1
              }
            ]
          },
          options: {
            tooltips: {
              mode: "index",
              intersect: false
            },
            responsive: true,
            legend: {
              display: true,
              position: "top"
            },
            title: {
              display: false,
              text: "Actividad diaria"
            },
            animation: {
              animateScale: true,
              animateRotate: true
            },
            circumference: Math.PI,
            rotation: -Math.PI,
            scales: {
              xAxes: [
                {
                  display: true,
                  stacked: false,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ],
              yAxes: [
                {
                  display: true,
                  stacked: false,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            },
            plugins: {
              zoom: {
                pan: {
                  enabled: true,
                  mode: "y",
                  speed: 0.5
                },
                zoom: {
                  enabled: true,
                  mode: "y"
                }
              }
            }
          }
        });

        let ctxYear = document.getElementById("chartYear").getContext("2d");
        this.myChartYear = new Chart(ctxYear, {
          type: "line",
          data: {
            labels: [
              "Ene",
              "Feb",
              "Mar",
              "Abr",
              "May",
              "Jun",
              "Jul",
              "Ago",
              "Sep",
              "Oct",
              "Nov",
              "Dic"
            ],
            datasets: [
              {
                label: "nº de alertas",
                lineTension: 0.2,
                borderWidth: 1,
                showLine: true,
                data: numAlertasYear,
                backgroundColor: "rgba(25,118,210,0.5)",
                borderColor: "rgba(25,118,210, 1)"
              },
              {
                label: "nº de activaciones",
                lineTension: 0.2,
                showLine: true,
                data: numActivacionesYear,
                backgroundColor: "rgba(255, 99, 132, 0.3)",
                borderColor: "rgba(255, 99, 132, 1)",
                borderWidth: 1
              }
            ]
          },
          options: {
            tooltips: {
              mode: "index",
              intersect: false
            },
            scales: {
              xAxes: [
                {
                  stacked: true,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ],
              yAxes: [
                {
                  stacked: false,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            },
            plugins: {
              zoom: {
                pan: {
                  enabled: true,
                  mode: "x",
                  speed: 0.5
                },
                zoom: {
                  enabled: true,
                  mode: "x"
                }
              }
            }
          }
        });

        let horas = [];
        let indice = 0;
        for (let hora = 0; hora < 24; hora += 1) {
          horas[indice] = "" + hora;
          indice++;
        }
        let ctxDay = document.getElementById("chartDay").getContext("2d");
        this.myChartDay = new Chart(ctxDay, {
          type: "bar",
          data: {
            labels: horas,
            datasets: [
              {
                label: "nº de alertas",
                lineTension: 0.2,
                borderWidth: 1,
                showLine: true,
                data: numAlertasDay,
                backgroundColor: "rgba(25,118,210,0.5)",
                borderColor: "rgba(25,118,210, 1)"
              },
              {
                label: "nº de activaciones",
                lineTension: 0.2,
                showLine: true,
                data: numActivacionesDay,
                backgroundColor: "rgba(255, 99, 132, 0.3)",
                borderColor: "rgba(255, 99, 132, 1)",
                borderWidth: 1
              }
            ]
          },
          options: {
            tooltips: {
              mode: "index",
              intersect: false
            },
            scales: {
              xAxes: [
                {
                  stacked: true,
                  display: true,
                  precision: 0,
                  scaleLabel: {
                    display: false,
                    labelString: "Hora"
                  },
                  ticks: {
                    beginAtZero: true
                  }
                }
              ],
              yAxes: [
                {
                  stacked: false,
                  display: true,
                  scaleLabel: {
                    display: false,
                    labelString: "Número"
                  },
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            },
            plugins: {
              zoom: {
                pan: {
                  enabled: true,
                  mode: "x",
                  speed: 0.5
                },
                zoom: {
                  enabled: true,
                  mode: "x"
                }
              }
            }
          }
        });
      }
    }
  },
  methods: {
    // @vuese
    // Genera las gráficas de la página principal
    // @arg Activaciones de los sensores del usuario
    generarGrafica() {
      let ctxGeneral = document.getElementById("chartGeneral").getContext("2d");
      this.myChartGeneral = new Chart(ctxGeneral, {
        type: "pie",
        data: {
          labels: [
            "Sensores",
            "Grupos",
            "Edificios",
            "Notificaciones",
            "Activaciones"
          ],
          datasets: [
            {
              label: "nº de alertas",
              lineTension: 0.2,
              borderWidth: 1.5,
              showLine: true,
              data: [this.sensores.length, this.grupos.length, this.edificios.length, this.notificaciones.length, this.activaciones.length],
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)'
              ],
              borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)'
              ],
            }
          ]
        },
        options: {
          tooltips: {
            mode: "index",
            intersect: true
          },
          responsive: true,
          legend: {
            display: true,
            position: "bottom"
          },
          title: {
            display: true,
            text: "Cantidad de registros"
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          // circumference: Math.PI,
          scales: {
            xAxes: [
              {
                display: false,
                stacked: false,
                ticks: {
                  beginAtZero: true
                }
              }
            ],
            yAxes: [
              {
                display: false,
                stacked: false,
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: "y",
                speed: 0.5
              },
              zoom: {
                enabled: true,
                mode: "y"
              }
            }
          }
        }
      });
    },
    generarGraficaSensors() {
      let nombres = [];
      let valores = [];
      if(this.sensoresMasActivos.length === 0){
        return;
      }
      for (let i = 0; i < this.sensoresMasActivos.length; i++) {
        nombres.push(this.sensoresMasActivos[i].name);
        valores.push(this.sensoresMasActivos[i].number);
      }
      let ctxGeneral = document.getElementById("chartSensors").getContext("2d");
      this.myChartGeneral = new Chart(ctxGeneral, {
        type: "doughnut",
        data: {
          labels: nombres.slice(0, 6),
          datasets: [
            {
              label: "nº de alertas",
              lineTension: 0.2,
              borderWidth: 1.5,
              showLine: true,
              data: valores.slice(0, 6),
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)'
              ],
              borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)'
              ],
            }
          ]
        },
        options: {
          tooltips: {
            mode: "index",
            intersect: true
          },
          responsive: true,
          legend: {
            display: true,
            position: "top"
          },
          title: {
            display: true,
            text: "Sensores más activos"
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          circumference: Math.PI,
          rotation: -Math.PI,
          scales: {
            xAxes: [
              {
                display: false,
                stacked: false,
                ticks: {
                  beginAtZero: true
                }
              }
            ],
            yAxes: [
              {
                display: false,
                stacked: false,
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: "y",
                speed: 0.5
              },
              zoom: {
                enabled: true,
                mode: "y"
              }
            }
          }
        }
      });
    },
    // @vuese
    // Reinicia el zoom de las gráficas
    reiniciarZoom() {
      this.myChartDay.resetZoom();
      this.myChartWeek.resetZoom();
      this.myChartGeneral.resetZoom();
      this.myChartYear.resetZoom();
    },
    // @vuese
    // Procesa un objeto date y lo muestra formateado
    // @arg Fecha
    mostrarFecha(fecha) {
      if (fecha === null || fecha === undefined) {
        return "";
      }
      let dateStr = JSON.parse('"' + fecha + '"');
      let date = new Date(dateStr);
      return date.toLocaleString("es-ES");
    },
    // @vuese
    // Procesa un objeto date y devuelve el número de semana
    // @arg Fecha
    getWeekNumber(fecha) {
      let date = new Date(fecha.valueOf());
      date.setHours(0, 0, 0, 0);
      // Thursday in current week decides the year.
      date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
      // January 4 is always in week 1.
      var week1 = new Date(date.getFullYear(), 0, 4);
      // Adjust to Thursday in week 1 and count number of weeks from date to week1.
      return (
        1 +
        Math.round(
          ((date.getTime() - week1.getTime()) / 86400000 -
            3 +
            ((week1.getDay() + 6) % 7)) /
            7
        )
      );
    }
  },
  computed: {
    // @vuese
    // Indica si algún componente está cargando
    algoCargando() {
      return (
        this.loadingNotifications ||
        this.loadingSensors ||
        this.loadingGroups ||
        this.loadingBuildings ||
        this.loadingActivations
      );
    },
    // @vuese
    // Devuelve el ID del usuario
    getUID() {
      return this.$store.state.user.uid;
    },
    // @vuese
    // Devuelve el año actual
    year() {
      var d = new Date();
      return d.getFullYear();
    },
    // @vuese
    // Devuelve la fecha actual formateada
    day() {
      var date = new Date();
      return (
        date
          .toLocaleDateString("es", { weekday: "long" })
          .charAt(0)
          .toUpperCase() +
        date.toLocaleDateString("es", { weekday: "long" }).slice(1) +
        " " +
        date.getDate() +
        " de " +
        date.toLocaleDateString("es", { month: "long" }) +
        " de " +
        date.getFullYear()
      );
    },
    // @vuese
    // Devuelve el número de semana
    week() {
      var date = new Date();
      date.setHours(0, 0, 0, 0);
      // Thursday in current week decides the year.
      date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
      // January 4 is always in week 1.
      var week1 = new Date(date.getFullYear(), 0, 4);
      // Adjust to Thursday in week 1 and count number of weeks from date to week1.
      return (
        1 +
        Math.round(
          ((date.getTime() - week1.getTime()) / 86400000 -
            3 +
            ((week1.getDay() + 6) % 7)) /
            7
        )
      );
    }
  }
};
</script>
